var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart-container"},[_c('div',{ref:"chart",staticClass:"line-chart",style:({ width: _vm.adaptiveWidth+ 'px', height: _vm.height + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }